module.exports = __webpack_public_path__ + "size2.png";